import { takeLatest, put, call, select } from 'redux-saga/effects';

import { forceQuoteItemRecalculation } from 'modules/quotes/quoteItems/data/actions';
import { refreshQuoteItemSaga } from 'modules/quotes/quoteItems/data/sagas';

import service from 'services/quoteService';

import { types, updateQuantities } from './actions';
import { getComponentId, getQuoteItemId } from './selectors';

export default function* root() {
  yield takeLatest(
    types.UPDATE_QUANTITIES_REQUEST,
    watchUpdateQuantitiesRequest,
  );
}

function* watchUpdateQuantitiesRequest(action) {
  const { data } = action.payload;
  const componentId = yield select(getComponentId);
  const quoteItemId = yield select(getQuoteItemId);

  try {
    yield call(service.quantities.bulkCRUD, componentId, data);

    // update the quote item
    try {
      yield call(refreshQuoteItemSaga, quoteItemId);
      yield put(forceQuoteItemRecalculation.success({ quoteItemId }));
    } catch (e) {
      yield put(forceQuoteItemRecalculation.error({ quoteItemId }));
      throw new Error(e);
    }

    yield put(updateQuantities.success());
  } catch (error) {
    yield put(updateQuantities.failure(error));
  }
}
